module.exports = __webpack_public_path__ + "static/media/video_5.b05df59.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_10/video_5.mp4
// module id = dXIz
// module chunks = 0